// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","container":"_3SJf8fu3RYrev6hH6EhwAQ","error":"_1yR5tnSzNvg1ezv1TWdW5E","nav":"_3wm7I_oan5MRiRL_whOlAD"};